export default __webpack_public_path__ + "static/media/Domingo Candelas.0e053363.jpg";